<main>
  <h2>Code Collaboration</h2>
  <h3>Bring your OS ecosystem together.</h3>
  <div class="cardrow">
    <div class="card profiles-screenshot">
      <div class="text">
        <h4 class="cardtitle">Profiles</h4>
        <p>Everyone has a profile across Radicle</p>
      </div>
    </div>
    <div class="card issues-screenshot">
      <div class="text">
        <h4 class="cardtitle">Issues</h4>
        <p>Create and track issues</p>
      </div>
    </div>
    <div class="card patches-screenshot">
      <div class="text">
        <h4 class="cardtitle">Patches</h4>
        <p>Collaborate and contribute on work</p>
      </div>
    </div>
  </div>
</main>
